import { InitializeInAppType } from '../../global-actions/types';
import get from 'lodash/get';

const registrationReducers = {
  userAnswerSuccess: (
    userStore,
    payload: {
      creditWaitlistEnabledForFlow: boolean;
      createUserExtras: unknown | undefined;
    }
  ) => {
    if (payload.createUserExtras) {
      return {
        ...userStore,
        creditWaitlistEnabledForFlow: payload.creditWaitlistEnabledForFlow,
        registeredUser: {
          ...userStore.registeredUser,
          token: get(payload.createUserExtras, 'token')
            ? get(payload.createUserExtras, 'token')
            : get(userStore.registeredUser, 'token'),
          user: get(payload.createUserExtras, 'user')
            ? get(payload.createUserExtras, 'user')
            : get(userStore.registeredUser, 'user')
        }
      };
    }
    return {
      ...userStore,
      creditWaitlistEnabledForFlow: payload.creditWaitlistEnabledForFlow
    };
  },

  userCheckValidEmailSuccess: (userStore, payload) => ({
    ...userStore,
    emailCorrection: payload.corrected || null
  }),

  userCompleteSuccess: (userStore, payload) => ({
    ...userStore,
    shouldGetPricingPlanAfterComplete: true,
    registeredUser: payload.extras
      ? { ...userStore.registeredUser, ...payload.extras[0] }
      : { ...userStore.registeredUser }
  }),

  userGetAnswersSuccess: (
    userStore,
    payload: { setPartnerSource?: string; setReferralCode?: string }
  ) => ({
    ...userStore,
    partner: payload.setPartnerSource || userStore.partner,
    promotionId: payload.setReferralCode || userStore.promotionId
  }),

  userGetPricingPlanSuccess: (userStore, payload: { current: string }) => ({
    ...userStore,
    currentPlan: payload.current
  }),

  userGetPricingPlanFailure: (userStore, payload: { current: string }) => ({
    ...userStore,
    currentPlan: null
  }),

  userQueryGetInitialFundingSuccess: (
    userStore,
    payload: { amount: number }
  ) => ({
    ...userStore,
    initialLoadAmount: payload.amount
  }),

  userVerifyPromoCodeSuccess: (userStore, payload: string) => ({
    ...userStore,
    promoCode: payload
  }),

  setPmaFinalTarget: (
    userStore,
    payload: { phoneNumber: string; deviceUuid: string; nextRegStep: string }
  ) => ({
    ...userStore,
    tempPhoneNumber: payload.phoneNumber,
    deviceToken: payload.deviceUuid,
    nextRegStep: payload.nextRegStep,
    needsAccessRequest: false
  }),

  userSetInitializeInAppProperties: (
    userStore,
    payload: InitializeInAppType['payload']
  ) => {
    const inAppPreReg = payload.preregisteredUserId && !payload.authToken;

    return {
      ...userStore,
      tempPhoneNumber: payload.phoneNumber,
      role: payload.role,
      registeredUser: {
        ...(userStore.registeredUser || {}),
        token: payload.authToken,
        id: payload.preregisteredUserId
      },
      nextRegStep: 'register',
      isParentInvitedByChild: inAppPreReg && payload.role === 'parent',
      isChildInvitedByParent: inAppPreReg && payload.role === 'child'
    };
  },

  setInAppUserPropertiesOnAnswer: (
    userStore,
    payload: { questions: Array<string>; answers: Array<string>; token: string }
  ) => userStore,

  setPreRegPlanSelection: (userStore, payload: { plan: string }) => ({
    ...userStore,
    preRegPlanSelection: payload.plan
  }),

  setReferralRewardValue: (userStore, referralRewardValue) => ({
    ...userStore,
    referralRewardValue: referralRewardValue
  }),
  userInitializeSuccess: (
    userStore,
    payload: { authToken: string; preregisteredUserId: string }
  ) => ({
    ...userStore,
    inAppPreReg: payload.preregisteredUserId && !payload.authToken
  }),
  userInitializeFailure: (userStore, payload: { response: any }) => ({
    ...userStore,
    nextRegStep:
      payload.response.status === 401 ? 'phone' : userStore.nextRegStep
  }),
  userGetFailureReasonSuccess: (app, payload: { data: any }) => ({
    ...app,
    failureReason: payload.data.failureType,
    hasExceededMaxVerificationAttempts:
      payload.data.userHasExceededMaxVerificationAttempts
  }),
  userGetFailureReasonFailure: app => ({
    ...app,
    failureReason: 'compliance_risk',
    hasExceededMaxVerificationAttempts: true
  })
};

export default registrationReducers;
